module.exports = __webpack_public_path__ + "static/media/checks.f44579fd.svg";